/**
 * cinema
 */
export default {
  namespaced: true,
  state: {
    cinema: null
  },
  
  mutations: {
    SET_CINEMA (state, value) {
      state.cinema = value
    }
  },
  getters: {
    cinema: (state) => state.cinema
  }
}
